import { GoogleStreetViewWidgetConfiguration } from "src/dynamic-view-renderer/Widgets/GoogleMapsWidget/GoogleStreetViewWidget";
import { SimpleCompany } from "src/dynamic-view-renderer/Widgets/GoogleMapsWidget/useLocation";
import { getElementByPath } from "src/dynamic-view-renderer/Widgets/WidgetProperties/widgetProperties.utils";
import { useFormatElementPropertyValue } from "src/hooks/useFormatElementPropertyValue";
import { Element } from "src/types/element.ts";

export const useCompanyInfo = (
  elements: Element[],
  config?: GoogleStreetViewWidgetConfiguration
): SimpleCompany | null => {
  const formatElementPropertyValue = useFormatElementPropertyValue();
  const companyElement = getElementByPath(elements, config?.companyElementPath ?? "");

  if (!companyElement) return null;

  return {
    name: formatElementPropertyValue(companyElement, config?.companyNamePropertyName),
    address: formatElementPropertyValue(companyElement, config?.companyAddressPropertyName),
    siren: formatElementPropertyValue(companyElement, config?.companySirenPropertyName),
  };
};
